import * as React from 'react';

type HeadsetSvgProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const HeadsetSvg: React.FC<HeadsetSvgProps> = ({ width = 24, height = 24, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 18 20" {...props}>
    <path
      d="M16 13.5V16.5C16 17.05 15.55 17.5 15 17.5H14V13.5H16ZM4 13.5V17.5H3C2.45 17.5 2 17.05 2 16.5V13.5H4ZM9 0.5C4.03 0.5 0 4.53 0 9.5V16.5C0 18.16 1.34 19.5 3 19.5H6V11.5H2V9.5C2 5.63 5.13 2.5 9 2.5C12.87 2.5 16 5.63 16 9.5V11.5H12V19.5H15C16.66 19.5 18 18.16 18 16.5V9.5C18 4.53 13.97 0.5 9 0.5Z"
      fill="white"
    />
  </svg>
);
export default HeadsetSvg;
